export const dropshippingProducts = [
  {
    id: 1,
    name: "Wireless Noise-Cancelling Headphones Pro",
    originalPrice: "$89.99",
    salePrice: "$34.50",
    margin: "62%",
    stock: 847,
    maxStock: 1000,
    category: "Electronics",
    image: "https://public.readdy.ai/ai/img_res/a1a3fc1273d66ab7ace32a59780c0c5b.jpg",
    supplier: "TechDirect HK",
    supplierId: 1,
    shipping: "5-8 days",
    sold: 1243,
    commission: 0.12,
  },
  {
    id: 2,
    name: "Portable Blender — USB Rechargeable",
    originalPrice: "$45.00",
    salePrice: "$18.20",
    margin: "59%",
    stock: 312,
    maxStock: 500,
    category: "Kitchen",
    image: "https://readdy.ai/api/search-image?query=portable%20USB%20blender%20kitchen%20appliance%20colorful%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop2&orientation=squarish",
    supplier: "HomeGoods SZ",
    supplierId: 2,
    shipping: "7-12 days",
    sold: 876,
    commission: 0.10,
  },
  {
    id: 3,
    name: "LED Ring Light 18-inch with Tripod",
    originalPrice: "$65.00",
    salePrice: "$22.80",
    margin: "65%",
    stock: 156,
    maxStock: 300,
    category: "Photography",
    image: "https://readdy.ai/api/search-image?query=LED%20ring%20light%20photography%20tripod%20studio%20equipment%20white%20clean%20background%20product&width=260&height=260&seq=drop3&orientation=squarish",
    supplier: "PhotoPro GZ",
    supplierId: 3,
    shipping: "6-10 days",
    sold: 534,
    commission: 0.15,
  },
  {
    id: 4,
    name: "Smart Watch Fitness Tracker Series 6",
    originalPrice: "$120.00",
    salePrice: "$41.00",
    margin: "66%",
    stock: 523,
    maxStock: 800,
    category: "Wearables",
    image: "https://readdy.ai/api/search-image?query=smart%20watch%20fitness%20tracker%20black%20premium%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop4&orientation=squarish",
    supplier: "WearTech SZ",
    supplierId: 4,
    shipping: "5-9 days",
    sold: 2108,
    commission: 0.12,
  },
  {
    id: 5,
    name: "Ergonomic Office Chair Lumbar Support",
    originalPrice: "$280.00",
    salePrice: "$98.00",
    margin: "65%",
    stock: 89,
    maxStock: 200,
    category: "Furniture",
    image: "https://readdy.ai/api/search-image?query=ergonomic%20office%20chair%20black%20lumbar%20support%20premium%20product%20white%20clean%20background&width=260&height=260&seq=drop5&orientation=squarish",
    supplier: "FurniDirect GD",
    supplierId: 5,
    shipping: "10-15 days",
    sold: 312,
    commission: 0.08,
  },
  {
    id: 6,
    name: "Stainless Steel Water Bottle 1L",
    originalPrice: "$35.00",
    salePrice: "$9.80",
    margin: "72%",
    stock: 1200,
    maxStock: 1500,
    category: "Sports",
    image: "https://readdy.ai/api/search-image?query=stainless%20steel%20water%20bottle%201%20liter%20sports%20outdoor%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop6&orientation=squarish",
    supplier: "EcoGoods YW",
    supplierId: 6,
    shipping: "4-7 days",
    sold: 3421,
    commission: 0.10,
  },
  {
    id: 7,
    name: "Mini Projector 4K Portable",
    originalPrice: "$199.00",
    salePrice: "$72.00",
    margin: "64%",
    stock: 234,
    maxStock: 400,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=mini%20projector%204K%20portable%20home%20cinema%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop7&orientation=squarish",
    supplier: "TechDirect HK",
    supplierId: 1,
    shipping: "6-10 days",
    sold: 689,
    commission: 0.12,
  },
  {
    id: 8,
    name: "Bamboo Desk Organizer Set",
    originalPrice: "$42.00",
    salePrice: "$14.50",
    margin: "65%",
    stock: 678,
    maxStock: 900,
    category: "Office",
    image: "https://readdy.ai/api/search-image?query=bamboo%20desk%20organizer%20set%20office%20accessories%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop8&orientation=squarish",
    supplier: "EcoGoods YW",
    supplierId: 6,
    shipping: "5-8 days",
    sold: 1102,
    commission: 0.10,
  },
  {
    id: 9,
    name: "Resistance Bands Set — 5 Levels",
    originalPrice: "$38.00",
    salePrice: "$11.20",
    margin: "70%",
    stock: 1450,
    maxStock: 2000,
    category: "Fitness",
    image: "https://readdy.ai/api/search-image?query=resistance%20bands%20set%20fitness%20exercise%20colorful%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop9&orientation=squarish",
    supplier: "FitSupply GZ",
    supplierId: 7,
    shipping: "4-7 days",
    sold: 2876,
    commission: 0.10,
  },
  {
    id: 10,
    name: "Aromatherapy Diffuser with LED",
    originalPrice: "$55.00",
    salePrice: "$19.90",
    margin: "64%",
    stock: 389,
    maxStock: 600,
    category: "Home",
    image: "https://readdy.ai/api/search-image?query=aromatherapy%20diffuser%20LED%20light%20home%20wellness%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop10&orientation=squarish",
    supplier: "HomeGoods SZ",
    supplierId: 2,
    shipping: "6-9 days",
    sold: 945,
    commission: 0.10,
  },
  {
    id: 11,
    name: "Wireless Charging Pad 3-in-1",
    originalPrice: "$75.00",
    salePrice: "$26.80",
    margin: "64%",
    stock: 712,
    maxStock: 1000,
    category: "Electronics",
    image: "https://readdy.ai/api/search-image?query=wireless%20charging%20pad%203%20in%201%20phone%20watch%20earbuds%20product%20white%20clean%20background%20studio&width=260&height=260&seq=drop11&orientation=squarish",
    supplier: "WearTech SZ",
    supplierId: 4,
    shipping: "5-8 days",
    sold: 1567,
    commission: 0.12,
  },
  {
    id: 12,
    name: "Foldable Laptop Stand Aluminum",
    originalPrice: "$48.00",
    salePrice: "$16.50",
    margin: "66%",
    stock: 543,
    maxStock: 800,
    category: "Office",
    image: "https://readdy.ai/api/search-image?query=foldable%20laptop%20stand%20aluminum%20silver%20product%20white%20clean%20background%20studio%20office&width=260&height=260&seq=drop12&orientation=squarish",
    supplier: "TechDirect HK",
    supplierId: 1,
    shipping: "5-8 days",
    sold: 788,
    commission: 0.10,
  },
];

export const dropshippingSuppliers = [
  {
    id: 1,
    name: "TechDirect HK",
    country: "Hong Kong",
    avatar: "https://readdy.ai/api/search-image?query=tech%20company%20logo%20modern%20minimalist%20electronics%20brand%20identity%20clean%20white%20background&width=80&height=80&seq=sup1&orientation=squarish",
    products: 38,
    rating: 4.9,
    totalSold: 12400,
    joined: "Jan 2022",
  },
  {
    id: 2,
    name: "HomeGoods SZ",
    country: "Shenzhen, China",
    avatar: "https://readdy.ai/api/search-image?query=home%20goods%20company%20logo%20modern%20minimalist%20kitchen%20brand%20identity%20clean%20white%20background&width=80&height=80&seq=sup2&orientation=squarish",
    products: 54,
    rating: 4.7,
    totalSold: 8900,
    joined: "Mar 2022",
  },
  {
    id: 3,
    name: "PhotoPro GZ",
    country: "Guangzhou, China",
    avatar: "https://readdy.ai/api/search-image?query=photography%20equipment%20company%20logo%20modern%20minimalist%20brand%20identity%20clean%20white%20background&width=80&height=80&seq=sup3&orientation=squarish",
    products: 22,
    rating: 4.8,
    totalSold: 5300,
    joined: "Jun 2022",
  },
  {
    id: 4,
    name: "WearTech SZ",
    country: "Shenzhen, China",
    avatar: "https://readdy.ai/api/search-image?query=wearable%20tech%20company%20logo%20modern%20minimalist%20smartwatch%20brand%20identity%20clean%20white%20background&width=80&height=80&seq=sup4&orientation=squarish",
    products: 31,
    rating: 4.6,
    totalSold: 18700,
    joined: "Sep 2021",
  },
];

export const dropshippingInfluencers = [
  {
    id: 1,
    name: "Kevin Park",
    platform: "Facebook",
    platformIcon: "ri-facebook-circle-fill",
    platformColor: "text-sky-400",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20male%20entrepreneur%20dropshipping%20expert%20portrait%20confident%20clean%20studio%20headshot&width=300&height=300&seq=inf7&orientation=squarish",
    specialty: "Dropship King",
    followers: "980K",
    productsSold: 3842,
    commissionEarned: "$18,420",
    topProduct: "Smart Watch Fitness Tracker Series 6",
    conversionRate: "8.4%",
    badge: "Top Earner",
  },
  {
    id: 2,
    name: "Lily Thompson",
    platform: "TikTok",
    platformIcon: "ri-tiktok-fill",
    platformColor: "text-white",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20HR%20expert%20portrait%20energetic%20smile%20clean%20studio%20background%20headshot&width=300&height=300&seq=inf6&orientation=squarish",
    specialty: "Lifestyle & Products",
    followers: "5.1M",
    productsSold: 6210,
    commissionEarned: "$31,050",
    topProduct: "Resistance Bands Set — 5 Levels",
    conversionRate: "12.1%",
    badge: "Viral Seller",
  },
  {
    id: 3,
    name: "Natasha Brown",
    platform: "YouTube",
    platformIcon: "ri-youtube-fill",
    platformColor: "text-red-400",
    avatar: "https://readdy.ai/api/search-image?query=professional%20black%20female%20lifestyle%20career%20influencer%20portrait%20warm%20smile%20clean%20studio%20headshot&width=300&height=300&seq=inf8&orientation=squarish",
    specialty: "Lifestyle & Reviews",
    followers: "4.2M",
    productsSold: 4567,
    commissionEarned: "$22,835",
    topProduct: "Wireless Noise-Cancelling Headphones Pro",
    conversionRate: "9.7%",
    badge: "Rising Star",
  },
  {
    id: 4,
    name: "Marcus Johnson",
    platform: "YouTube",
    platformIcon: "ri-youtube-fill",
    platformColor: "text-red-400",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20career%20coach%20portrait%20confident%20smile%20clean%20background%20studio%20headshot&width=300&height=300&seq=inf1&orientation=squarish",
    specialty: "Tech & Gadgets",
    followers: "2.4M",
    productsSold: 2890,
    commissionEarned: "$14,450",
    topProduct: "Mini Projector 4K Portable",
    conversionRate: "7.2%",
    badge: "Consistent",
  },
  {
    id: 5,
    name: "Sophia Chen",
    platform: "TikTok",
    platformIcon: "ri-tiktok-fill",
    platformColor: "text-white",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20female%20finance%20expert%20portrait%20confident%20clean%20studio%20background%20headshot&width=300&height=300&seq=inf2&orientation=squarish",
    specialty: "Finance & Deals",
    followers: "3.8M",
    productsSold: 5120,
    commissionEarned: "$25,600",
    topProduct: "Stainless Steel Water Bottle 1L",
    conversionRate: "11.3%",
    badge: "Deal Hunter",
  },
  {
    id: 6,
    name: "David Williams",
    platform: "Facebook",
    platformIcon: "ri-facebook-circle-fill",
    platformColor: "text-sky-400",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20mentor%20portrait%20mature%20confident%20clean%20background%20headshot&width=300&height=300&seq=inf3&orientation=squarish",
    specialty: "Business & Products",
    followers: "1.2M",
    productsSold: 1980,
    commissionEarned: "$9,900",
    topProduct: "Ergonomic Office Chair Lumbar Support",
    conversionRate: "6.1%",
    badge: "Steady Growth",
  },
];
